export default {
  tag: {
    type: String,
    default: 'div',
  },
}
